<ng-container *transloco="let t">
  @if (!!gpx || controlPointsList.length > 0 && (race?.raceSettings?.displayControlPoints ?? false)) {
    <div class="pb-300-100">
      <div class="nav-bar-padding">
        <div class="nav_tabs container container-no-padding-sm">
          <div class="py-2">
            @if (race?.raceSettings?.enableGPXDownload && activeTabId === 1) {
              <div class="d-flex flex-row justify-content-center align-items-center ">
                <app-rounded-button [label]="t('app.map.download.gpx.file')"
                                    [btnClass]="'rounded-button--highlight'" (onClick)="downloadGPXFile()">
                  <i class="bi bi-download pe-2"></i></app-rounded-button>
              </div>
            }
          </div>
          <div>
            <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId">
              <!-- Profile Tab -->
              @if (!!gpx) {
                <li [ngbNavItem]="1" class="item">
                  <button ngbNavLink class="nav-button">{{ t("race.details.map") }}</button>
                  <ng-template ngbNavContent>
                    <div class="container container-no-padding-sm">
                      <div>
                        <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [increaseMapHeight]="true"
                                          [points]="waypointList" [gpx]="gpx"
                                          [defaultLanguage]="eventItem?.defaultLanguage"
                                          [languages]="languages"/>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <!-- Profile Tab -->
                <li [ngbNavItem]="2" class="item">
                  <button ngbNavLink class="nav-button">{{ t("race.details.profile") }}</button>
                  <ng-template ngbNavContent>
                    <app-race-profile [defaultLanguage]="eventItem?.defaultLanguage" [gpx]="gpx"
                                      [controlPointsList]="gpxWaypoints" [elevationStats]="waypointsStats"
                                      [languages]="languages"></app-race-profile>
                  </ng-template>

                </li>
              }

              @if (controlPointsList.length > 0 && (race?.raceSettings?.displayControlPoints ?? false)) {
                <li [ngbNavItem]="3" class="item">
                  <button ngbNavLink class="nav-button">{{ t("race.details.checkpoints.table") }}</button>
                  <ng-template ngbNavContent>
                    <div class="container container-no-padding-sm">
                      <app-control-points-table [controlPointsList]="controlPointsList" [race]="race"
                                                [languages]="languages"/>
                    </div>
                  </ng-template>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
      <div [ngbNavOutlet]="nav" class="pt-4"></div>
    </div>

  } @else {
    <div class="container container-no-padding-sm">
      <div class="pt-62-32 pb-300-100">
        <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [increaseMapHeight]="true"
                          [points]="waypointList" [gpx]="gpx"
                          [defaultLanguage]="eventItem?.defaultLanguage"
                          [languages]="languages"/>
      </div>
    </div>
  }
</ng-container>
